import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { LinkButton } from 'commonComponents/LinkButton';

import { PersonAddIcon } from 'icons';
import { ROLE_DEFINITIONS } from 'roles/definitions';
import { RoleDependentComponent } from 'roles/RoleDependentComponent';
import { ROUTES } from 'routes/routes';

export function UserListButtons() {
    const theme = useTheme();
    return (
        <Box
            sx={{
                display: 'flex',
                gap: theme.spacing(2),
            }}
        >
            <RoleDependentComponent
                title="Create"
                userRole={ROLE_DEFINITIONS.Administrator}
                component={LinkButton}
                iconClass={PersonAddIcon}
                route={ROUTES.USER_CREATE}
                data-testid="FilterUsers_CreateUser"
            />
        </Box>
    );
}
